import { gql } from '@apollo/client';

const CREATE_PROPERTY = gql`
mutation CreateProperty($property: VrboPropertyInput!) {
    createProperty(property: $property) {
        ... on VrboProperty {
            listingTriad,
            expediaId,
            isCreatedByInternalUser            
        }
        ... on ResponseRedirect {
            isRedirect,
            route
        }
    }
}
`;

const FETCH_VRBO_USER_INFO = gql`
query fetchVrboUserInformation($locale: String!) {
    fetchVrboUserInformation(locale: $locale) {
        hasPhoneNumber,
        hasPasswordSet,
        hasOwnerAccount,
        hasOwnerAccountOnCurrentSite,
        hasAdvertiserOnCurrentSite,
        phoneNumber,
        phoneCountryCode,
        phoneCountryCodeDigits
    }
}
`;

export {
    // eslint-disable-next-line import/prefer-default-export
    CREATE_PROPERTY,
    FETCH_VRBO_USER_INFO
};
